import {styled} from "@reside/ui";

export const AlignRight = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;
